import styled from 'styled-components';
import { Molecule } from 'AppReact';
import { GenericWrapper } from 'wrappers';
import { SecondaryTextXs300, SecondaryTextSmBold, SecondaryTextSm, Icon } from 'atoms';
import { CornerExpandSvg } from 'components/icons';
import { format } from 'date-fns';

const template = styled.div`
  border-bottom: 1px solid #E3E3E3;
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  padding: 16px 20px;

  &:hover {
    background-color: #E8F8F0;
  }
`

export default Molecule({
  type: 'button',
  template,
  atoms: [
    {
      wrapper: GenericWrapper,
      name: 'OrderInfo',
      atoms: [
        {
          component: SecondaryTextXs300,
          name: 'ParentCategory',
          displayValue: ({ order }) => order.parent_category_name ?? '',
        },
        {
          component: SecondaryTextSmBold,
          name: 'Category',
          displayValue: ({ order }) => order.category_name ?? '',
        },
        {
          component: SecondaryTextSm,
          name: 'Status',
          displayValue: ({ order }) => {
            let status = '';
            if (order.status === 'assigned') {
              status = `Assigned to ${order.assigned_to}`
            }
            if (order.status === 'unassigned') {
              status = 'Unassigned'
            }
            if (order.status === 'completed') {
              status = 'Completed'
            }
            if (order.status === 'cancelled') {
              status = 'Canceled'
            }
            return status;
          }
        },
        {
          component: SecondaryTextXs300,
          name: 'Date',
          displayValue: ({ order }) => {
            let status = '';
            status = order.inserted_at ? format(order.inserted_at, 'MM-dd-yyyy') : ''
            if (order.status === 'completed') {
              status = order.completed_at ? format(order.completed_at, 'MM-dd-yyyy') : ''
            }
            return status;
          }
        },
      ]
    },
    {
      component: Icon,
      name: 'Icon',
      displayValue: ({ }) => CornerExpandSvg({})
    }

  ]
})